import EULA from "@/assets/EULA.html";

export default {
	required: true,
	text: EULA,
	updated_at: "2018-08-31T16:11:00+00:00"
};



// WEBPACK FOOTER //
// ./src/services/EULA.js